import React from 'react';

import { Select } from '@gogame/components';
import { withFormField, omitFormProps } from '@gogame/form';

const EMPTY_OPTIONS = [];

const BusinessPartnersFormField = withFormField()(({
  area,
  form,
  name,
  value,
  onChange,
  ...props
}) => {
  const handleChange = (e, value) => {
    onChange(e, [value]);
  };

  return (
    <Select
      {...omitFormProps(props)}
      value={value?.[0]}
      onChange={handleChange}
      loading={area.loading}
      options={area.data || EMPTY_OPTIONS}
    />
  );
});

export default BusinessPartnersFormField;
